import { useState } from 'react';

import styled from '@emotion/styled';

import PreviewImageIcon from '../../Icons/PreviewImageIcon';
import { Modal } from '../../Modal/Modal';
import PreviewImageModal from '../../Modal/ModalActions/PreviewImageModal/PreviewImageModal';

interface TableImageModalProps {
  data?: Record<string, any>;
  dataKey: string;
}

const TableImageModal: React.FC<TableImageModalProps> = ({ data, dataKey }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(!showModal);
  };
  return (
    <>
      <Container onClick={handleClick}>
        View Image <PreviewImageIcon />
      </Container>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <PreviewImageModal imgUrl={data?.[dataKey]} />
      </Modal>
    </>
  );
};

export default TableImageModal;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 16px;
  align-items: center;
  margin-right: auto;
  gap: 8px;
  cursor: pointer;
`;
